<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Carrello</h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-5xl">
      <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
        <form @submit.prevent="storeSale">
          <text-input v-model="form.sku" :error="form.errors.sku" class="pr-6 pb-3 w-full lg:w-1/1" label="SKU" />
          <!-- <input ref="input" class="terminal-input" autofocus v-model="message"/>  -->
        </form>
        <!-- <input v-model="form.sku" :error="form.errors.sku" class="form-input pr-6 pb-3 w-full lg:w-1/3" @keyup.enter="storeSale()" /> -->
        <!-- <StreamBarcodeReader @decode="onDecode" @loaded="onLoaded"></StreamBarcodeReader> -->
        <!-- <select-input v-model="form.batch_id" :error="form.errors.batch_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Lotto">
            <option :value="null" />
            <option v-for="batch in batches" :key="batch.id" :value="batch.id">{{ batch.nome }}</option>
          </select-input> -->
      </div>
      <!-- <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
        <multiselect class="lg:w-1/2" v-model="form.selectedCustomer" id="customer_id" placeholder="Cerca cliente"
          :options="customers" :custom-label="phoneWithEmail" label="phone" track-by="id"
          @search-change="onSearchCustomersChange" @input="onSelectedCustomer" />
      </div> -->
      <div class="bg-white rounded-md shadow overflow-x-auto">
        <table class="w-full whitespace-nowrap">
          <tr class="text-left font-bold">
            <th class="px-6 pt-6 pb-3">SKU</th>
            <th class="px-6 pt-6 pb-3">Nome</th>
            <th class="px-6 pt-6 pb-3">Prezzo</th>
            <th class="px-6 pt-6 pb-3">Opzioni</th>
          </tr>
          <tr v-for="item in cart" :key="item.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              {{ item.sku }}
            </td>
            <td class="border-t">{{ item.name }}</td>
            <td class="border-t">{{ item.prezzo_unitario }} €</td>
            <td class="border-t">
              <button @click="destroy(item.id)">Elimina</button>
            </td>
          </tr>
          <tr v-if="cart.length === 0">
            <td class="border-t px-6 py-4" colspan="4">Nessun prodotto</td>
          </tr>
        </table>
      </div>
      <pagination class="mt-6" :links="cart" />

      <div class="px-8 py-2 bg-gray-50 flex justify-end items-center">
        <h3 class="mb-1 font-bold text-1xl">Totale: € {{ total.toFixed(2) }}</h3>
      </div>
      <div class="px-8 py-2 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
        <h1 class="mb-1 font-bold text-2xl">Totale con 10%: €{{ totaleScontato.toFixed(2) }}</h1>
      </div>
      <div class="px-8 py-2 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
        <h1 class="mb-1 font-bold text-2xl">Totale con 15%: €{{ totaleScontato15.toFixed(2) }}</h1>
      </div>
      <div class="px-8 py-2 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
        <h1 class="mb-1 font-bold text-2xl">Totale con 20%: €{{ totaleScontato20.toFixed(2) }}</h1>
      </div>
      <div class="px-8 py-2 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
        <h1 class="mb-1 font-bold text-2xl">Totale con 30%: €{{ totaleScontato30.toFixed(2) }}</h1>
      </div>
      <div class="px-8 py-2 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
        <h1 class="mb-1 font-bold text-2xl">Totale con 50%: €{{ totaleScontato50.toFixed(2) }}</h1>
      </div>
      <div class="px-8 py-2 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
        <h1 class="mb-1 font-bold text-2xl">Totale con 70%: €{{ totaleScontato70.toFixed(2) }}</h1>
      </div>
      <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
        <button class="btn-indigo" @click="store()">Crea Vendita</button>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import { StreamBarcodeReader } from 'vue-barcode-reader'
import Icon from '@/Shared/Icon'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
// import Multiselect from 'vue-multiselect'

export default {
  metaInfo: { title: 'Crea Vendita' },
  components: {
    LoadingButton,
    SelectInput,
    StreamBarcodeReader,
    TextInput,
    Icon,
    Pagination,
    SearchFilter,
    // Multiselect,
  },
  layout: Layout,
  props: {
    batches: Array,
    // customers: {
    //   type: Array,
    //   default: () => []
    // },
    cart: Array,
    error: String,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        sku: null,
        // selectedCustomer: undefined,
        // customer_id: null,
      }),
    }
  },
  methods: {
    // onSearchCustomersChange(term) {
    //   this.$inertia.get('cart', { term }, {
    //     preserveState: true,
    //     preserveScroll: true,
    //     replace: true
    //   })
    // },
    // onSelectedCustomer(customer) {
    //   this.form.customer_id = customer.id;
    // },
    // phoneWithEmail({ phone, email }) {
    //   return `${phone} — [${email}]`
    // },
    onEnter() {
      console.log('pressed enter')
    },
    storeSale() {
      if (navigator.onLine) {
        this.form.post(this.route('cart.store')), this.form.reset()
      } else {
        this.$page.props.flash.error = 'Controllare la connessione e ricaricare la pagina'
      }
    },
    store(sku) {
      if (navigator.onLine) {
        //this.form.post(this.route('order.store', sku, customer_id)), this.form.reset() DA ABILITARE QUANDO SI UTILIZZERA UTENTE ASSOCIATO AL CARRELLO
        this.form.post(this.route('order.store', sku)), this.form.reset()
      } else {
        this.$page.props.flash.error = 'Controllare la connessione e ricaricare la pagina'
      }
    },
    destroy(id) {
      if (navigator.onLine) {
        this.form.delete(this.route('cart.destroy', id))
      } else {
        this.$page.props.flash.error = 'Controllare la connessione e ricaricare la pagina'
      }
    },
    onDecode(text) {
      console.log(`Decode text from QR code is ${text}`)
    },
    onLoaded() {
      console.log(`Ready to start scanning barcodes`)
    },
  },
  computed: {
    totaleScontato: function () {
      let sum = 0
      // return this.cart.reduce((sum, item) => sum + item.prezzo_unitario, 0)
      return this.cart.reduce((sum, item) => sum + item.prezzo_unitario - (item.prezzo_unitario * 10) / 100, 0)
    },
    totaleScontato15: function () {
      let sum = 0
      // sum = this.cart.reduce((sum, item) => sum + item.prezzo_unitario - (item.prezzo_unitario * 10) / 100, 0)
      // sum = sum - (sum * 5) / 100
      // return sum
      return this.cart.reduce((sum, item) => sum + item.prezzo_unitario - (item.prezzo_unitario * 15) / 100, 0)

    },
    totaleScontato20: function () {
      let sum = 0
      return this.cart.reduce((sum, item) => sum + item.prezzo_unitario - (item.prezzo_unitario * 20) / 100, 0)

    },
    totaleScontato30: function () {
      let sum = 0
      return this.cart.reduce((sum, item) => sum + item.prezzo_unitario - (item.prezzo_unitario * 30) / 100, 0)

    },
    totaleScontato50: function () {
      let sum = 0
      return this.cart.reduce((sum, item) => sum + item.prezzo_unitario - (item.prezzo_unitario * 50) / 100, 0)

    },
    totaleScontato70: function () {
      let sum = 0
      return this.cart.reduce((sum, item) => sum + item.prezzo_unitario - (item.prezzo_unitario * 70) / 100, 0)

    },
    total: function () {
      let sum = 0
      return this.cart.reduce((sum, item) => sum + item.prezzo_unitario, 0)
    },
  },
}
</script>
